import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import OrganisationCreation from '../OrganisationCreation'

import * as superAdminActions from '../../ducks/super-admin'

class OrganisationCreationContainer extends React.Component {
  render() {
    return <OrganisationCreation onAdd={this.props.actions.addOrganisation} />
  }
}

function mapStateToProps(state) {
  return {
    currentAccount: state.account.get('currentAccount')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(superAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationCreationContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationCreationContainer.js